import { createGlobalStyle } from 'styled-components'

import { ThemeModes } from './theme'

const GlobalStyle = createGlobalStyle`
*, *::before, *::after {
    box-sizing: border-box;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    margin: 0;
    padding: 0;
}

html {
    font-size: ${({ theme }) => theme.fontSize} !important;
}

body {
    font-family: 'Inter', 'Roboto', sans-serif;
    background-color: ${({ theme }) =>
        theme.mode === ThemeModes.HIGH_CONTRAST
            ? theme?.highContrast?.colorBgBase
            : theme.colorBgBase} !important;

    & {
        ul, p {
            margin: 0;
        }
    }

    a {
        color: ${({ theme }) =>
            theme.mode === ThemeModes.HIGH_CONTRAST
                ? theme?.highContrast?.primary
                : theme.primary};
    }

    p,
    b,
    li:not(.ant-pagination-item),
    h1,
    h2,
    h3,
    h4,
    h5,
    h6,
    mark {
        color: ${({ theme }) =>
            theme.mode === ThemeModes.HIGH_CONTRAST &&
            theme?.highContrast?.primary} !important;

        a {
            text-decoration: ${({ theme }) =>
                theme.mode === ThemeModes.HIGH_CONTRAST ? 'underline' : 'none'};
        }
    }

    .ant-checkbox .ant-checkbox-inner:after {
        border-color: ${({ theme }) =>
            theme.mode === ThemeModes.HIGH_CONTRAST &&
            theme?.highContrast?.colorBtnText};
    }

    button.ant-btn-primary:not([disabled]), .ant-picker-cell-selected .ant-picker-cell-inner {
        color: ${({ theme }) =>
            theme.mode === ThemeModes.HIGH_CONTRAST &&
            theme?.highContrast?.colorBtnText} !important;
    }


    h1,
    h2,
    h3,
    h4,
    h5 {
        font-size: 3rem !important;
    }

    .smaller-heading {
        font-size: 2rem !important
    }

    a,
    p,
    b,
    td,
    th,
    div.ant-tabs-extra-content > div > button.ant-btn > span,
    label > span,
    div.ant-tabs-tabpane ul > li,
    input.ant-input,
    .ant-tabs-tab-btn,
    label.ant-form-item-required,
    div.ant-select,
    span.ant-badge-status-text,
    .ant-tooltip-inner ul.additional-info-list,
    span > input,
    button {
        font-size: 1.4rem !important;
    }

    span.ant-tag {
        font-size: 1.2rem !important;
    }

    .ant-tag-red {
        background-color: ${({ theme }) =>
            theme.mode === ThemeModes.HIGH_CONTRAST && theme?.red?.['100']};
        color: ${({ theme }) =>
            theme.mode === ThemeModes.HIGH_CONTRAST && theme?.red?.['900']};
    }

    .ant-tag-geekblue {
        background-color: ${({ theme }) =>
            theme.mode === ThemeModes.HIGH_CONTRAST &&
            theme?.geekblue?.['300']};
        color: ${({ theme }) =>
            theme.mode === ThemeModes.HIGH_CONTRAST &&
            theme?.geekblue?.['900']};
    }

    .ant-tag-blue {
        background-color: ${({ theme }) =>
            theme.mode === ThemeModes.HIGH_CONTRAST && theme?.blue?.['100']};
        color: ${({ theme }) =>
            theme.mode === ThemeModes.HIGH_CONTRAST && theme?.blue?.['900']};
    }

    .ant-tag-purple {
        background-color: ${({ theme }) =>
            theme.mode === ThemeModes.HIGH_CONTRAST && theme?.purple?.['100']};
        color: ${({ theme }) =>
            theme.mode === ThemeModes.HIGH_CONTRAST && theme?.purple?.['900']};
    }

    .ant-tag-green {
        background-color: ${({ theme }) =>
            theme.mode === ThemeModes.HIGH_CONTRAST && theme?.green?.['100']};
        color: ${({ theme }) =>
            theme.mode === ThemeModes.HIGH_CONTRAST && theme?.green?.['900']};
    }

    .ant-tag-magenta {
        background-color: ${({ theme }) =>
            theme.mode === ThemeModes.HIGH_CONTRAST && theme?.magenta?.['100']};
        color: ${({ theme }) =>
            theme.mode === ThemeModes.HIGH_CONTRAST && theme?.magenta?.['900']};
    }

    .ant-tag-volcano {
        background-color: ${({ theme }) =>
            theme.mode === ThemeModes.HIGH_CONTRAST && theme?.volcano?.['100']};
        color: ${({ theme }) =>
            theme.mode === ThemeModes.HIGH_CONTRAST && theme?.volcano?.['900']};
    }

    button.ant-btn {
        height: 3rem;
    }

    .visuallyHidden {
        border: 0;
        clip: rect(0 0 0 0);
        height: 1px;
        margin: -1px;
        overflow: hidden;
        padding: 0;
        position: absolute;
        width: 1px;
    }

}
`

export default GlobalStyle
